export const edcRatesContants = {
  GET_ALL_EDC_RATES: "GET_ALL_EDC_RATES",
};
